import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShield = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.319 10.342L11.171 14.49L8.682 12.001M19.1 5.92099C16.641 5.72699 14.403 4.74799 12.637 3.23299C12.275 2.92299 11.724 2.92299 11.363 3.23299C9.597 4.74699 7.359 5.72699 4.9 5.92099C4.388 5.96099 4 6.39899 4 6.91199V11.242C4 15.609 7.156 19.704 11.478 20.927C11.817 21.023 12.184 21.023 12.523 20.927C16.844 19.703 20 15.61 20 11.243V6.91299C20 6.39899 19.612 5.96099 19.1 5.92099Z",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgShield);
export default ForwardRef;
